import { render } from "./twelve-chest.vue?vue&type=template&id=f6e1dd54"
import script from "./twelve-chest.vue?vue&type=script&lang=js"
export * from "./twelve-chest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__